export const bankList = [
    { code: "VCB", name: "Vietcombank", logo: "https://api.vietqr.io/img/VCB.png" },
    { code: "BIDV", name: "BIDV", logo: "https://api.vietqr.io/img/BIDV.png" },
    { code: "CTG", name: "VietinBank", logo: "https://my.sepay.vn/assets/images/banklogo/vietinbank.png" },
    { code: "TCB", name: "Techcombank", logo: "https://api.vietqr.io/img/TCB.png" },
    { code: "MB", name: "MB Bank", logo: "https://api.vietqr.io/img/MB.png" },
    { code: "ACB", name: "ACB", logo: "https://api.vietqr.io/img/ACB.png" },
    { code: "VPB", name: "VPBank", logo: "https://api.vietqr.io/img/VPB.png" },
    { code: "TPB", name: "TPBank", logo: "https://api.vietqr.io/img/TPB.png" },
    { code: "STB", name: "Sacombank", logo: "https://api.vietqr.io/img/STB.png" },
    { code: "HDB", name: "HDBank", logo: "https://api.vietqr.io/img/HDB.png" },
    { code: "VIB", name: "VIB", logo: "https://api.vietqr.io/img/VIB.png" },
    { code: "MSB", name: "MSB", logo: "https://api.vietqr.io/img/MSB.png" },
    { code: "SHB", name: "SHB", logo: "https://api.vietqr.io/img/SHB.png" },
    { code: "OCB", name: "OCB", logo: "https://api.vietqr.io/img/OCB.png" },
    { code: "EIB", name: "Eximbank", logo: "https://api.vietqr.io/img/EIB.png" },
    { code: "LPB", name: "LPBank", logo: "https://api.vietqr.io/img/LPB.png" },
    { code: "SEAB", name: "SeABank", logo: "https://api.vietqr.io/img/SEAB.png" },
    { code: "ABB", name: "ABBank", logo: "https://api.vietqr.io/img/ABB.png" },
    { code: "BAB", name: "Bac A Bank", logo: "https://api.vietqr.io/img/BAB.png" },
    { code: "PGB", name: "PG Bank", logo: "https://api.vietqr.io/img/PGB.png" },
    { code: "NAB", name: "Nam A Bank", logo: "https://api.vietqr.io/img/NAB.png" },
    { code: "KLB", name: "KienlongBank", logo: "https://api.vietqr.io/img/KLB.png" },
    { code: "SCB", name: "SCB", logo: "https://api.vietqr.io/img/SCB.png" },
    { code: "VAB", name: "VietABank", logo: "https://api.vietqr.io/img/VAB.png" },
    { code: "BVB", name: "BaoViet Bank", logo: "https://api.vietqr.io/img/BVB.png" },
    { code: "IVB", name: "Indovina Bank", logo: "https://api.vietqr.io/img/IVB.png" },
    { code: "CBB", name: "CB Bank", logo: "https://api.vietqr.io/img/CBB.png" },
    { code: "GPB", name: "GPBank", logo: "https://api.vietqr.io/img/GPB.png" },
    { code: "Oceanbank", name: "OceanBank", logo: "https://api.vietqr.io/img/OCEANBANK.png" },
    { code: "UOB", name: "UOB Vietnam", logo: "https://api.vietqr.io/img/UOB.png" },
    { code: "HSBC", name: "HSBC Vietnam", logo: "https://api.vietqr.io/img/HSBC.png" },
    { code: "SCVN", name: "Standard Chartered", logo: "https://api.vietqr.io/img/SCVN.png" },
    { code: "SHBVN", name: "Shinhan Bank", logo: "https://api.vietqr.io/img/SHBVN.png" },
    { code: "HLBVN", name: "Hong Leong Bank", logo: "https://api.vietqr.io/img/HLBVN.png" },
    { code: "PBVN", name: "Public Bank Vietnam", logo: "https://api.vietqr.io/img/PBVN.png" }
];
export const bankListSorted = [...bankList].sort((a, b) =>
    a.name.localeCompare(b.name, "vi")
);